/**
 * Firebase App Check - Protección contra abuso y bots
 * 
 * Usa reCAPTCHA v3 en web para validar requests legítimos
 */

import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { app } from './firebaseConfig';
import { Environment } from '../config/environment';

let appCheckInitialized = false;

/**
 * Inicializar App Check (solo una vez)
 */
export function initAppCheck() {
  // Solo ejecutar una vez
  if (appCheckInitialized) return;

  if (Environment.isNative()) {
    return;
  }
  
  const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
  
  // Si no hay key configurada, solo alertar en dev
  if (!RECAPTCHA_SITE_KEY) {
    if (import.meta.env.DEV) {
      console.warn('⚠️ VITE_RECAPTCHA_SITE_KEY no configurado - App Check deshabilitado');
    }
    return;
  }

  try {
    // En desarrollo, usar debug token para evitar problemas
    if (import.meta.env.DEV) {
      // Debug token debe configurarse en Firebase Console
      (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
    }

    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(RECAPTCHA_SITE_KEY),
      isTokenAutoRefreshEnabled: true
    });

    appCheckInitialized = true;
    
    if (import.meta.env.DEV) {
      console.log('✅ App Check inicializado');
    }
  } catch (error) {
    console.error('❌ Error inicializando App Check:', error);
  }
}
